import { useQuery } from '@tanstack/react-query';
import { IPartner } from '../../interfaces/Partner';
import { getPartners } from '../../services/partners.service';
import { backendErrorsHandler } from '../../utils/Notification/BackendErrorsHandler';

export const partnersQueryKey = ['partners'];

export const useGetPartners = (enabled = true) => useQuery<IPartner[]>({
  queryKey: partnersQueryKey,
  enabled,
  queryFn: async () => {
    try {
      const res = await getPartners();
      if (!Array.isArray(res?.data?.data)) {
        throw new Error('Oh no! Something went wrong while fetching partners.');
      }
      return res.data.data;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      backendErrorsHandler(e);
      throw e;
    }
  }
});
